import { Injectable } from '@angular/core';
import * as data from '../../../assets/data/homepage-content.json';
@Injectable({
  providedIn: "root"
})
export class HomepageContentService {
  getHomepageData() {
    return data.default
  }
}